import { UserGroups } from "libs/types/user";

export default (claims: { "cognito:groups": UserGroups[] }): boolean =>
  claims["cognito:groups"].includes("ExternalDoctor");
